"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var LinkButton_1 = __importDefault(require("../../Button/LinkButton"));
var DatePicker_1 = __importDefault(require("../../DatePicker/DatePicker"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var StyledLabel = styled_components_1.default(Label_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: baseline;\n  margin-top: 1em;\n"], ["\n  align-self: baseline;\n  margin-top: 1em;\n"])));
var CloseIconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 17px;\n  margin-left: 10px;\n"], ["\n  margin-top: 17px;\n  margin-left: 10px;\n"])));
var CloseIcon = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  color: #005285;\n  font-size: 16px;\n  text-align: inherit;\n"], ["\n  cursor: pointer;\n  color: #005285;\n  font-size: 16px;\n  text-align: inherit;\n"])));
var FlexBox = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  margin-bottom: 1em;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  margin-bottom: 1em;\n"])));
var DateFieldAdd = function (_a) {
    var name = _a.name, label = _a.label, minDate = _a.minDate, readOnlyIds = _a.readOnlyIds, maxSize = _a.maxSize, disabled = _a.disabled;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var value = field.value || [];
    react_1.useEffect(function () {
        if (!value.length) {
            helpers.setValue(ramda_1.append(undefined, value));
        }
    }, []);
    react_1.useEffect(function () {
        if (minDate) {
            value.forEach(function (v, index) {
                var _a;
                if ((v === null || v === void 0 ? void 0 : v.datum) && new Date(v.datum).toISOString() < minDate.toISOString() && !(readOnlyIds === null || readOnlyIds === void 0 ? void 0 : readOnlyIds.includes(v === null || v === void 0 ? void 0 : v.id))) {
                    helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), { datum: minDate.toISOString(), id: (_a = value[index]) === null || _a === void 0 ? void 0 : _a.id }, value));
                }
            });
        }
    }, [minDate]);
    var handleAddDate = function () {
        helpers.setValue(ramda_1.append(undefined, value));
    };
    var handleRemoveDate = function (index) {
        helpers.setValue(ramda_1.remove(index, 1, value));
    };
    var handleChange = function (d, index) {
        var _a;
        if (d === null) {
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), undefined, value));
        }
        else {
            var x = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            x.setFullYear(d.getFullYear());
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), { datum: x.toISOString(), id: (_a = value[index]) === null || _a === void 0 ? void 0 : _a.id }, value));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Field_1.default, null,
            label && react_1.default.createElement(StyledLabel, { htmlFor: utils_1.NormalizeString(name) }, label),
            react_1.default.createElement("div", null,
                ramda_1.addIndex(ramda_1.map)(function (date, index) {
                    var readOnly = (readOnlyIds === null || readOnlyIds === void 0 ? void 0 : readOnlyIds.includes(date === null || date === void 0 ? void 0 : date.id)) || disabled;
                    return (react_1.default.createElement(FlexBox, { key: index },
                        react_1.default.createElement(DatePicker_1.default, { onChange: function (d) { return handleChange(d, index); }, value: date === null || date === void 0 ? void 0 : date.datum, key: "date-" + index, name: name, minDate: readOnly ? undefined : minDate, readOnly: readOnly, clearIcon: readOnly ? null : undefined }),
                        index > 0 && !readOnly && (react_1.default.createElement(CloseIconWrapper, null,
                            react_1.default.createElement(CloseIcon, { onClick: function () { return handleRemoveDate(index); }, key: "remove-" + index })))));
                }, value),
                (maxSize === undefined || value.length < maxSize) && !disabled && (react_1.default.createElement(LinkButton_1.default, { type: "button", onClick: handleAddDate, name: "PridatObor" }, "+ P\u0159idat dal\u0161\u00ED"))))));
};
DateFieldAdd.defaultProps = {
    minDate: undefined,
    readOnlyIds: undefined,
    maxSize: undefined,
    disabled: false,
};
exports.default = DateFieldAdd;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
